export default __webpack_public_path__ + "890fba372a7526826b5fd9760cf4ee47.png";